import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { CroppedImageView } from '@bingads-webui-campaign-react/cropped-image-view';

import { withUAPLThemedStyles } from '../../with-themed-styles';
import { getBoostWindowsSpotlight191x100Styles } from '../../styles';
import {
  MMAPlacementCard,
} from '../../shared-components';
import searchIcon from '../media/search.svg';
import cameraIcon from '../media/camera.svg';
import batteryIcon from '../media/battery.svg';
import wifiIcon from '../media/wifi.svg';

const WindowsSpotlight191x100 = ({
  placementData, // UAPVMSingleImagePlacement
  isEnabled,
  finalUrl,
  hotspots,
  i18n,
  classes,
}) => {
  const {
    placementMeta, placementCropping, imageMeta, effectiveImageUrl, effectiveImageWidth, effectiveImageHeight, expandedPlacementCropping,
  } = placementData || {};
  const { previewHeight, aspectRatio } = placementMeta || {};
  if (!placementData || !imageMeta) {
    return null;
  }

  // const srcForCroppedImageView = showImage && this.props.image.FinalSrc;
  const imagePreviewWidth = previewHeight * aspectRatio;

  const cropping = expandedPlacementCropping || placementCropping;

  const hotspot1 = hotspots && hotspots[0];
  const hotspot1Center = hotspot1 && hotspot1.placement === 'Center';
  const hotspot1Topleft = hotspot1 && hotspot1.placement === 'TopLeft';
  const hotspot2 = hotspots && hotspots[1];
  const hotspot2Center = !hotspot1Center && hotspot2 && hotspot2.placement === 'Center';
  const hotspot2Topleft = !hotspot1Topleft && hotspot2 && hotspot2.placement === 'TopLeft';

  return (
    <MMAPlacementCard url={finalUrl} width={imagePreviewWidth} isEnabled={isEnabled} mmaPlacementCardClassName={classes.placementCard}>
      <div className={classnames(classes.placementImageContainer)}>
        {
          imageMeta.url &&
          <CroppedImageView
            resizeImageHeight={previewHeight}
            aspectRatio={aspectRatio}
            src={effectiveImageUrl || imageMeta.url}
            originalWidth={effectiveImageWidth || imageMeta.originalWidth}
            originalHeight={effectiveImageHeight || imageMeta.originalHeight}
            SourceX={cropping && cropping.SourceX}
            SourceY={cropping && cropping.SourceY}
            SourceWidth={cropping && cropping.SourceWidth}
            SourceHeight={cropping && cropping.SourceHeight}
          />
        }
      </div>
      <div className="hardcode-time" >
        <div className="time" >{i18n.getString(_TL_('10:36'))}</div>
        <div className="date" >{i18n.getString(_TL_('Tuesday, October 18'))}</div>
      </div>
      <div className={classes.placementCenterSection}>
        <img className={classes.placementSearchIconCenter} alt="" src={searchIcon} />
        <div className={classes.placementHotspotsCenterSection}>
          {
              hotspot1Center &&
              (
                // eslint-disable-next-line react/no-array-index-key
                <div className="hotspot0" key={`${hotspots[0].title}0`}>
                  <div className="hotspot-title" >{hotspots[0].title}</div>
                  <div className="hotspot-desc" >{hotspots[0].desc}</div>
                  <div className="hotspot-action" >{hotspots[0].actionText}</div>
                </div>
              )
            }
          {
              hotspot2Center &&
              (
                // eslint-disable-next-line react/no-array-index-key
                <div className="hotspot1" key={`${hotspots[1].title}1`}>
                  <div className="hotspot-title" >{hotspots[1].title}</div>
                  <div className="hotspot-desc" >{hotspots[1].desc}</div>
                  <div className="hotspot-action" >{hotspots[1].actionText}</div>
                </div>
              )
            }
        </div>
      </div>
      <div className={classnames(classes.placementTextContainer)}>
        <div className={classes.placementTopRightSection}>
          <img className={classes.placementCameraIcon} alt="" src={cameraIcon} />
          <div className={classes.placementHeadlineTopRight} >{i18n.getString(_TL_('Like the image that you see?'))}</div>
        </div>
        <div className={classes.placementTopLeftSection}>
          <img className={classes.placementSearchIconTopLeft} alt="" src={searchIcon} />
          <div className={classes.placementHotspotsLeftSection}>
            {
              hotspot1Topleft &&
              (
                // eslint-disable-next-line react/no-array-index-key
                <div className="hotspot0" key={`${hotspots[0].title}0`}>
                  <div className="hotspot-title" >{hotspots[0].title}</div>
                  <div className="hotspot-desc" >{hotspots[0].desc}</div>
                  <div className="hotspot-action" >{hotspots[0].actionText}</div>
                </div>
              )
            }
            {
                hotspot2Topleft &&
                (
                  // eslint-disable-next-line react/no-array-index-key
                  <div className="hotspot1" key={`${hotspots[1].title}1`}>
                    <div className="hotspot-title" >{hotspots[1].title}</div>
                    <div className="hotspot-desc" >{hotspots[1].desc}</div>
                    <div className="hotspot-action" >{hotspots[1].actionText}</div>
                  </div>
                )
              }
          </div>
        </div>
      </div>
      <img className={classes.placementWifiIcon} alt="" src={wifiIcon} />
      <img className={classes.placementBatteryIcon} alt="" src={batteryIcon} />
    </MMAPlacementCard>
  );
};

WindowsSpotlight191x100.propTypes = {
  placementData: PropTypes.shape({}).isRequired, // UAPVMSingleImagePlacement
  isEnabled: PropTypes.bool,
  finalUrl: PropTypes.string,
  hotspots: PropTypes.arrayOf(PropTypes.shape({
    placement: PropTypes.string,
    title: PropTypes.string,
    desc: PropTypes.string,
    actionText: PropTypes.string,
  })),
  i18n: PropTypes.shape({}).isRequired,
  classes: PropTypes.shape({
    placementTextContainer: PropTypes.string,
    placementCenterSection: PropTypes.string,
    placementHotspotsCenterSection: PropTypes.string,
    placementTopRightSection: PropTypes.string,
    placementTopLeftSection: PropTypes.string,
    placementHotspotsLeftSection: PropTypes.string,
    placementImageContainer: PropTypes.string,
    placementCard: PropTypes.string,
    placementHeadlineTopRight: PropTypes.string,
    placementSearchIconCenter: PropTypes.string,
    placementSearchIconTopLeft: PropTypes.string,
    placementCameraIcon: PropTypes.string,
    placementWifiIcon: PropTypes.string,
    placementBatteryIcon: PropTypes.string,
  }).isRequired,
};

WindowsSpotlight191x100.defaultProps = {
  isEnabled: true,
  finalUrl: undefined,
  hotspots: [],
};

export const AdPlacementBoostWindowsSpotlight191x100 = withUAPLThemedStyles(
  WindowsSpotlight191x100,
  getBoostWindowsSpotlight191x100Styles,
  { componentName: 'AdPlacementBoostWindowsSpotlight191x100' }
);

export const UnstyledWindowsSpotlight191x100 = WindowsSpotlight191x100;
